import React, { useEffect, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import styled from '@emotion/styled';

import { notifySpinnerTimeout } from 'connectors/bugsnag';

import { loadingState } from 'state/atoms';
import { Spinner } from 'components/loaders';

const Overlay = styled.div`
  background: #fff;
  opacity: 0.8;
  width: 100vw;
  height: 100vh;
  z-index: 1500;
  position: fixed;
  top: 0;
  bottom: 0;
  display: ${({ show }) => (show ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
`;

const LoaderOverlay = () => {
  const isLoading = useRecoilValue(loadingState);
  const loaderTimeout = useRef(null);

  const timeLimit = process.env.REACT_APP_SPINNER_TIME_LIMIT;

  useEffect(() => {
    if (isLoading) {
      loaderTimeout.current = setTimeout(
        () => notifySpinnerTimeout(timeLimit),
        timeLimit * 1000
      );
    } else if (loaderTimeout.current) {
      clearTimeout(loaderTimeout.current);
    }
  }, [isLoading, timeLimit]);

  return (
    <Overlay show={isLoading}>
      <Spinner />
    </Overlay>
  );
};

export { LoaderOverlay };
